import React from 'react'
import {useRouteLoaderData} from 'react-router-dom'
import {Project} from '../../../entities/project'
import {GeneralProjectInfoForm} from '../../generalProjectInfoForm/generalProjectInfoForm'

const validateMessages = {
  required: '${label} is required!',
}

export function EditorGeneralProjectInfo() {
  const {project} = useRouteLoaderData('project') as {project: Project}

  return (
    <div>
      <GeneralProjectInfoForm project={project}></GeneralProjectInfoForm>
    </div>
  )
}
